import { Component, ElementRef, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { uploadService } from './../../../../shared/uploadService';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { NgForm } from '@angular/forms';
import { NewsService } from '../../services/news-service';
import { News } from '../../models/news';
import { FileVm } from '../../../../shared/Models/fileVm';
import { combineLatest } from 'rxjs';
import { finalize, switchMap, map, tap } from 'rxjs/operators';
import * as momentHijri from 'moment-hijri';
import { Router } from '@angular/router';

@Component({
  selector: 'app-add-news',
  templateUrl: './add-news.component.html',
  styleUrls: ['./add-news.component.scss'],
})
export class AddNewsComponent implements OnInit {
  isLoading: boolean = false;
  model = {} as News;
  isEdit = false;
  previosusAttachments: FileVm[] = [];
  fileName: string[] = [];
  date: Date = new Date();
  validPhoto: boolean = true;
  imgURL: string;
  formData = new FormData();
  attachements: FormData;
  uploadThumbnail = false;
  newPhotoUploaded = false;
  constructor(
    private diagRef: NbDialogRef<AddNewsComponent>,
    private service: NewsService,
    private uploadService: uploadService,
    private toast: NbToastrService,
    private route : Router
  ) {}

  ngOnInit() {
      this.route.events.subscribe(()=>{
      this.diagRef.close('false');
     });
    if (this.isEdit) {
      this.uploadService.updateFiles({ files: [], previousAttachments: this.model.attachements });
    }
    if (!this.isEdit) {
      this.model.descriptionAR = '';
      this.model.descriptionEN = '';
      this.attachements = new FormData();
      this.uploadThumbnail = true;
      this.validPhoto = false;
      this.uploadService.updateFiles({ files: [], previousAttachments: [] });
    }
  }

  removePhoot() {
    this.formData = new FormData();
    this.uploadThumbnail = true;
    this.validPhoto = false;
  }
  updateNews() {
    this.isLoading = true;
    const imgUpload$ = this.newPhotoUploaded
      ? this.uploadService.uploadImage(this.formData)
      : this.uploadService.uploadImage(this.model.thumbnail);
    const attachments$ = this.uploadService.uploadMultipleFiles();
    combineLatest([imgUpload$, attachments$])
      .pipe(
        switchMap(([img, file]) => {
          this.model.thumbnail = img;
          this.model.attachements = file;
          return this.service.put(this.model.id, this.model);
        })
      )
      .subscribe(
        () => {
          this.isLoading = false;
          this.diagRef.close('true');
          this.toast.show('تم تعديل الخبر بنجاح', '', { status: 'success', duration: 3000 });
        },
        (error) => {
          this.isLoading = false;
          console.error('Error while saving:', error);
          this.toast.show('حدث خطأ أثناء تعديل الخبر', '', { status: 'danger', duration: 3000 });
        }
      );
  }

  setDate(prop: string, event) {
    this.model.createdAt = event;
  }

  save() {
    if (!this.model.createdAt) {
      this.model.createdAt = momentHijri(new Date());
    }
    this.isLoading = true;

    const imgUpload$ = this.uploadService.uploadImage(this.formData);
    const attachments$ = this.uploadService.uploadMultipleFiles();
    combineLatest([imgUpload$, attachments$])
      .pipe(
        switchMap(([img, file]) => {
          this.model.thumbnail = img;
          this.model.attachements = file;
          return this.service.post(this.model);
        })
      )
      .subscribe(
        () => {
          this.isLoading = false;
          this.diagRef.close('true');
          this.toast.show('تم إضافة خبر جديد بنجاح', '', { status: 'success', duration: 3000 });
        },
        (error) => {
          this.isLoading = false;
          console.error('Error while saving:', error);
          this.toast.show('حدث خطأ أثناء إضافة الخبر', '', { status: 'danger', duration: 3000 });
        }
      );
  }

  getFormData(event) {
    this.formData = new FormData();
    this.formData = event;
    if (event) this.validPhoto = true;
    this.newPhotoUploaded = true;
  }

  close() {
    this.diagRef.close();
  }
}
